// extracted by mini-css-extract-plugin
module.exports = {"DocFooter":"styles-module--DocFooter--3eEhc"};